var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.005518175661563873 0 46.00551986694336 50.6199951171875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "o15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4 36.26a15.73 15.73 0 0 1-1.4-3.64C9.21 26.73 4.35 19.36 2.61 12.29A28.73 28.73 0 0 0 0 24.83v.41a47.24 47.24 0 0 0 15.4 11.02z",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 36.47c0-.07-.07-.15-.1-.21A47.24 47.24 0 0 1 0 25.23v.54a31 31 0 0 0 1.44 9.67 42.38 42.38 0 0 0 16.88 3.9 7.75 7.75 0 0 1-2.82-2.87z",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9 6.94Q33.79 0 23 0C17.18 0 12.41 1.54 8.64 4.58 7.94 12.16 10.18 19 13.16 26v-1.2a21.18 21.18 0 0 1 2.34-10.56 8 8 0 0 1 7.5-4.1 8.08 8.08 0 0 1 7.52 4.1 20.85 20.85 0 0 1 2.39 10.59v.95q0 6.62-2.37 10.68a8 8 0 0 1-7.46 4.06 9.25 9.25 0 0 1-4.75-1.16 42.38 42.38 0 0 1-16.88-3.9 23.18 23.18 0 0 0 4.67 8.24q6.11 6.92 17 6.92t16.78-6.94Q46 36.77 46 25.77v-.95q0-10.94-6.1-17.88z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.16 26c-3-7-5.23-13.86-4.53-21.44A20 20 0 0 0 6.11 7a23.19 23.19 0 0 0-3.49 5.33C4.35 19.36 9.21 26.73 14 32.62a26.57 26.57 0 0 1-.84-6.62z",
    fill: "#d9e021"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.abee5b8b8d42a75fd9b2696f21cf0632.svg";
export { ForwardRef as ReactComponent };